module.exports = __webpack_public_path__ + "fc3ce10bf55bf90b0c32a3bb76fc58a7.gif";